import { PaymentTypes, RequisiteSchema, RequisiteSchemaValidations } from '../entities';

export const getRequisitesSchemaByPaymentType = (paymentType: PaymentTypes): RequisiteSchema => {
    if (paymentType === PaymentTypes.BANK_TRANSFER_BSB) {
        return {
            bsb: {
                type: 'number',
                validation: [RequisiteSchemaValidations.REQUIRED]
            },
            accountNumber: {
                type: 'number',
                validation: [RequisiteSchemaValidations.REQUIRED]
            },
            accountName: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED]
            },
            firstName: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED]
            },
            secondName: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED]
            },
            email: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED, RequisiteSchemaValidations.EMAIL]
            }
        };
    } else if (paymentType === PaymentTypes.PAY_ID_EMAIL) {
        return {
            email: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED, RequisiteSchemaValidations.EMAIL]
            },
            firstName: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED]
            },
            secondName: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED]
            }
        };
    } else if (paymentType === PaymentTypes.PAY_ID_MOBILE) {
        return {
            mobileNumber: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED]
            },
            firstName: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED]
            },
            secondName: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED]
            }
        };
    } else if (paymentType === PaymentTypes.SOUTH_KOREA_BANK_TRANSFER) {
        return {
            bankName: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED]
            },
            bankAccountNumber: {
                type: 'number',
                validation: [RequisiteSchemaValidations.REQUIRED]
            },
            bankAccountHolderName: {
                type: 'string',
                validation: [RequisiteSchemaValidations.REQUIRED]
            }
        };
    }

    return {};
};
